export type Bonus = {
  number: string
  title: string
  body: string
  /** Optional cover image. Empty = the CSS cover in the product palette. */
  cover?: string
  /** Tailwind bg class for the CSS cover's accent band. */
  accent: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Start Anywhere: The 15-Minute Quick-Start Guide',
    body: 'Bought this mid-season? Start this week. A one-page decision path tells you which volume and week fits your room right now, and exactly which pages to read first.',
    cover: 'https://cdn.magicpatterns.com/uploads/vZCdMHu4uJhRd93oRCFUUH/bono-1--.webp',
    accent: 'bg-sage',
  },
  {
    number: '02',
    title: 'First-Timer Lane Room Signs & Level Markers',
    body: "Print, tape, teach: a 'First time? Stand here' sign, easy and hard lane cards and a props station sign that sort your room before you say a word. Letter and A4.",
    cover: 'https://cdn.magicpatterns.com/uploads/eAsht7tN72jHJLYdyXkdSv/bono-2--.webp',
    accent: 'bg-coral',
  },
  {
    number: '03',
    title: 'Studio-Ready Class Descriptions',
    body: 'Copy-paste descriptions for your schedule or booking app: 20 class blurbs in three lengths (one line, 40 and 80 words), plus a list of words to avoid.',
    cover: 'https://cdn.magicpatterns.com/uploads/hWbuoVUT3jW8i8opUcSbqK/bono-3--.webp',
    accent: 'bg-gold',
  },
  {
    number: '04',
    title: 'First-Timer Welcome Kit',
    body: 'Send it before their first class: what to wear, what to expect, when to arrive. Three short texts and one printable card, so you stop losing five minutes explaining everything.',
    cover: 'https://cdn.magicpatterns.com/uploads/4U6AE1EK6mupr4pQ8qnqrN/bono-4--.webp',
    accent: 'bg-smoke',
  },
  {
    number: '05',
    title: '10 Plan-Logistics Mistakes (and the Fix for Each)',
    body: 'The 10 logistics slips that derail a pre-written class — and the fix for each — on two pages you can read in five minutes.',
    cover: 'https://cdn.magicpatterns.com/uploads/fLGDBxgJgke62ZcHZtqnkC/bono-5--.webp',
    accent: 'bg-plum-mid',
  },
]
